"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.GroupsAPI = void 0;
const path_1 = require("../utils/path");
const utils_1 = require("../utils/utils");
class GroupsAPI {
    constructor(http) {
        this.http = http;
    }
    getAll() {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield this.http.get({
                path: path_1.GROUPS_API_URLS.USER_GROUPS,
            });
            const groupsDto = yield response.json();
            return groupsDto.map(utils_1.convertToGroupInterface);
        });
    }
    create(group) {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield this.http.post({
                path: path_1.GROUPS_API_URLS.GROUPS,
                data: group,
            });
            const groupDto = yield response.json();
            return (0, utils_1.convertToGroupInterface)(groupDto);
        });
    }
    update(id, group) {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield this.http.patch({
                path: `${path_1.GROUPS_API_URLS.GROUPS}${id}/`,
                data: group,
            });
            const groupDto = yield response.json();
            return (0, utils_1.convertToGroupInterface)(groupDto);
        });
    }
    delete(id) {
        return __awaiter(this, void 0, void 0, function* () {
            yield this.http.delete({
                path: `${path_1.GROUPS_API_URLS.GROUPS}${id}/`,
            });
        });
    }
    get(id) {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield this.http.get({
                path: `${path_1.GROUPS_API_URLS.GROUPS}${id}/`,
            });
            const groupDto = yield response.json();
            return (0, utils_1.convertToGroupInterface)(groupDto);
        });
    }
}
exports.GroupsAPI = GroupsAPI;
